//  If you want to continue using CSS stylesheets and classes...
//  https://github.com/airbnb/react-dates#initialize
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';

import React from 'react';
import moment from 'moment';
import i18n from '@ohif/i18n';
import { useTranslation } from 'react-i18next';
import 'react-dates/lib/css/_datepicker.css';
import { renderMonthElement } from './DateRangeUtils';
// import './CustomDateRangePicker.css';
import './CustomDateRangePicker.css';
import capitalizeFirst from '../util/string';

export const CustomDateRangePicker = (props) => {
  moment.locale(i18n.language); // using i18n in the date picker

  const { t } = useTranslation();
  const tr = (string) => capitalizeFirst(t(`studiesTable.${string.replace(/ /g, '.').toLowerCase()}`));
  const { presets, ...dateRangePickerProps } = props;

  return (
    <DateRangePicker
      {...dateRangePickerProps}
      renderMonthElement={renderMonthElement}
      startDatePlaceholderText={tr('start.date')}
      endDatePlaceholderText={tr('end.date')}
      phrases={{
        closeDatePicker: t('Common:Close'),
        clearDates: t('Clear dates'),
      }}
    />
  );
};
